import { FC, PropsWithChildren } from 'react';
import { useProfile } from 'core/auth';
import { PageViewportLayout } from '../template';
import { Button, Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface ErrorFrameProps {
  title: string,
  errorText?: string
}

export const ErrorFrame: FC<PropsWithChildren<ErrorFrameProps>> = ({ title, children, errorText }) => {
  const profile = useProfile();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
      <FInter.MainTitleMediumDiv color={theme.errorModal.textColor}>{title}</FInter.MainTitleMediumDiv>
      <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
        {children}
      </FInter.TextFlex>
      <FlexBox offsetLeftMobile={30} offsetRightMobile={30} widthMobile={320}>
        <FInter.SmallTextDiv color={Colors.geoWhite47}>
          PROFILE ID: {profile?.accountId} <br/> {window.location.href}
        </FInter.SmallTextDiv>
      </FlexBox>
      <FlexBox offsetTop={16}>
        <Button.YellowMedium onClick={() => window.history.back()}>{t('t.GoBack')}</Button.YellowMedium>
      </FlexBox>
      {(window.location.hostname.includes('onlinesdesign')) && errorText && (
        <FInter.TextFlex offsetTop={5} offsetBottom={10} color={'#b74848'}>
          {errorText}
        </FInter.TextFlex>
      )}
    </PageViewportLayout>
  );
};
import { FC, PropsWithChildren } from 'react';
import { useProfile } from 'core/auth';
import { PageViewportLayout } from '../template';
import { Button, Colors, FInter, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface ErrorFrameProps {
  title: string,
  errorText?: string
}

export const ErrorFrame: FC<PropsWithChildren<ErrorFrameProps>> = ({ title, children, errorText }) => {
  const profile = useProfile();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
      <FInter.MainTitleMediumDiv color={theme.errorModal.textColor}>{title}</FInter.MainTitleMediumDiv>
      <FInter.TextFlex offsetTop={16} offsetBottom={16} color={Colors.geoWhite73}>
        {children}
      </FInter.TextFlex>
      <FlexBox offsetLeftMobile={30} offsetRightMobile={30} widthMobile={320}>
        <FInter.SmallTextDiv color={Colors.geoWhite47}>
          PROFILE ID: {profile?.accountId} <br/> {window.location.href}
        </FInter.SmallTextDiv>
      </FlexBox>
      <FlexBox offsetTop={16}>
        <Button.YellowMedium onClick={() => window.history.back()}>{t('t.GoBack')}</Button.YellowMedium>
      </FlexBox>
      {(window.location.hostname.includes('onlinesdesign')) && errorText && (
        <FInter.TextFlex offsetTop={5} offsetBottom={10} color={'#b74848'}>
          {errorText}
        </FInter.TextFlex>
      )}
    </PageViewportLayout>
  );
};
